export default "__VITE_PUBLIC_ASSET__a5fe2806__"